import { render, staticRenderFns } from "./logDetail.vue?vue&type=template&id=c4a70d7c&scoped=true"
import script from "./logDetail.vue?vue&type=script&lang=js"
export * from "./logDetail.vue?vue&type=script&lang=js"
import style0 from "./logDetail.vue?vue&type=style&index=0&id=c4a70d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a70d7c",
  null
  
)

export default component.exports